<template>
  <el-container>
    <el-header class="table-header">
      <el-button type="primary" class="btn" size="small" @click="submit">{{$t('common.Save')}}</el-button>
    </el-header>
    <el-main class="table-main">
    <el-form ref="form" :rules="CommitForm" label-width="80px" :model="form" size="mini">
        <el-row :gutter="20">
          <el-divider content-position="left">{{$t('base.info.role.RoleInformation')}}</el-divider>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.role.RoleCode')" prop="code">
              <el-input v-model="form.code" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('base.info.role.RoleName')" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.Status')" prop="status">
              <template>
                <el-select v-model="form.status">
                  <el-option
                    v-for="item in options1"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('common.Type')" prop="type">
              <template>
                <el-select v-model="form.type">
                  <el-option
                    v-for="item in options2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('common.Remark')" prop="remark">
            <el-input v-model="form.remark" type="textarea"></el-input>
          </el-form-item>
        </el-col>
        </el-row>
      </el-form>
      <el-divider content-position="left">{{$t('base.info.role.AuthorityInformation')}}</el-divider>
      <el-table
        :data="tableData"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        height="400"
        default-expand-all
        :tree-props="{children: 'children',hasChildren: 'hasChildren'}"
        border stripe>
        <el-table-column
          type="index"
          fixed
          align="center">
        </el-table-column>
        <el-table-column
          prop="label"
          fixed
          width="150"
          :label="$t('base.info.role.ModelName')">
        </el-table-column>
        <template v-for='(col,index) in fData'>
          <el-table-column
            align="center"
            width="150%">
            <template slot-scope="scope" slot="header">
              <el-checkbox :indeterminate="isIndeterminate[index]" v-model="selectAll[index]"
                           @change="( (val) => handleCheckAllChange(val,index))">{{col.name}}
              </el-checkbox>
            </template>
            <template slot-scope="scope">
              <el-checkbox-group v-model="checks[index]"
                                 @change="((value) => handleCheckedCitiesChange(value,index))">
                <el-checkbox :label="scope.row.id" :key="scope.row.id">{{""}}</el-checkbox>
              </el-checkbox-group>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </el-main>
  </el-container>
</template>

<style>
  .btn {
    float: right;
    margin: 5px;
  }
  .row3 {
    padding-left: 10px;
  }
</style>

<script>

export default {
  data () {
    return {
      optionsSys: [],
      tableData: [],
      form: {
        systemId: 1,
        id: 0
      },
      options1: [{
        value: 10,
        label: this.$t('common.Draft')
      }, {
        value: 40,
        label: this.$t('common.Disable')
      }, {
        value: 50,
        label: this.$t('common.Normal')
      }],
      options2: [{
        value: 10,
        label: this.$t('base.info.role.SystemRetention')
      }, {
        value: 20,
        label: this.$t('base.info.role.Custom')
      }, {
        value: 50,
        label: this.$t('base.info.role.OnlineRegister')
      }],
      value: '',
      fData: [], // 所有功能信息
      selectAll: [], // 是否选择所有复选框
      isIndeterminate: [], // 是否未选择所有复选框
      checks: [], // 所选择的所有复选框的数据
      checksData: [], // 封装的数据，包含checks,code,roleId,systemId
      temp: [], // 临时数组的作用
      totalData: { // 传给后台的数据
        form: {},
        checksData: []
      },
      CommitForm: {
        name: [{required: true, trigger: 'blur', message: '角色名称不能为空'}],
        code: [{required: true, trigger: 'blur', message: '角色编号不能为空'}],
        remark: [{max: 90, message: '不能超过90个字符'}]
      },
      id: []
    }
  },
  methods: {
    handleCheckAllChange (val, index) {
      if (val) {
        this.$set(this.checks, index, this.id)
      } else {
        this.$set(this.checks, index, [])
      }
      this.$set(this.isIndeterminate, index, false)
    },
    handleCheckedCitiesChange (value, index) {
      let checkedCount = value.length
      this.$set(this.selectAll, index, checkedCount === this.id.length)
      this.$set(this.isIndeterminate, index, checkedCount > 0 && checkedCount < this.id.length)
    },
    // 初始化表行数据(base_menu表中数据)
    initMenu () {
      this.$api.menuList.findMenuBySystemId(this.qs.stringify({systemId: this.form.systemId})).then((response) => {
        this.tableData = response.data.data
        // 将tree型菜单数据的id存入id数组
        for (let j = 0; j < this.tableData.length; j++) {
          if (this.tableData[j].children.length > 0) {
            this.loop(this.tableData[j]) // 递归方法
          } else {
            this.id.push(this.tableData[j].id)
          }
        }
        this.initAllAuth()
      }).catch((error) => {
        console.log(error)
      })
    },
    // 初始化表头数据(base_function表中数据)
    initTableHead () {
      this.$api.functionList.functionfindBySystemId().then((response) => {
        this.fData = response.data.data
        // 初始化复选框表头数据
        for (let i = 0; i < this.fData.length; i++) {
          this.checks[i] = []
          this.isIndeterminate[i] = false
          this.selectAll[i] = false
          this.temp[i] = {code: this.fData[i].functId, col_index: i}
        }
        this.initMenu()
      }).catch((error) => {
        console.log(error)
      })
    },
    initAllAuth () {
      let param = {data: {systemId: this.form.systemId, roleId: this.form.id}}
      this.$api.auth.findAllAuth(param).then((response) => {
        // 渲染表列的复选框
        let aData = response.data.data
        this.dataParse(aData)
      }).catch((error) => {
        console.log(error)
      })
    },
    dataParse (aData) {
      let authData = []
      for (let i = 0; i < this.fData.length; i++) {
        authData[i] = {functId: this.fData[i].functId, menuIdList: []}
      }
      aData.forEach(item1 => {
        let fArray = item1.functIdList.split(';')
        fArray.forEach(item2 => {
          if (item2 === '') {
            return false
          }
          authData.forEach(item3 => {
            if (item2 == item3.functId) {
              item3.menuIdList.push(item1.menuId)
            }
          })
        })
      })
      for (let i = 0; i < authData.length; i++) {
        for (let j = 0; j < this.temp.length; j++) {
          let fCode = authData[i].functId
          let tCode = this.temp[j].code
          // 如果返回值中的数据有code与表格中的code相等
          if (fCode === tCode) {
            // 那么就把返回值中保存的menuid的数据根据temp建立的关系插入到checks数组中
            this.$set(this.checks, this.temp[j].col_index, authData[i].menuIdList)
            // 渲染表头的复选框
            let checkedCount = this.checks[this.temp[j].col_index].length
            this.$set(this.selectAll, this.temp[j].col_index, checkedCount === this.id.length)
            this.$set(this.isIndeterminate, this.temp[j].col_index, checkedCount > 0 && checkedCount < this.id.length)
          }
        }
      }
    },
    dataFormat () {
      // 初始化准备提交到后台的已勾选数据的格式
      for (let i = 0; i < this.id.length; i++) {
        this.checksData.push({menuId: this.id[i], idList: [], functIdList: ''})
      }
      // checks保存所有菜单的id,check[0]为勾选框的第一列所勾选的菜单id
      let count = 0
      this.checks.forEach(item => {
        // 对第一列勾选框进行遍历
        for (let i = 0; i < item.length; i++) {
          // 通过菜单id查找checksData中对应的数据，如果找到了，那么就将对应的功能id  push进这条数据
          for (let j = 0; j < this.checksData.length; j++) {
            if (item[i] === this.checksData[j].menuId) {
              this.checksData[j].idList.push(this.temp[count].code)
              break
            }
          }
        }
        count++
      })
      // 对checksData保存的数据格式化成后台需要的数据
      let dataAuth = []
      this.checksData.forEach((item, index) => {
        if (item.idList.length !== 0) {
          dataAuth.push(item)
        }
      })
      dataAuth.forEach(item => {
        let temp = ''
        for (let i = 0; i < item.idList.length; i++) {
          temp = `${temp}${item.idList[i]};`
        }
        item.functIdList = temp
        this.$delete(item, 'idList')
      })
      this.checksData = dataAuth.slice(0)
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.dataFormat()
          this.totalData.checksData = this.checksData
          this.totalData.form = this.form
          let param = {data: {authSaveReqs: this.totalData.checksData, roleUpdateReq: this.totalData.form}}
          this.$api.roleList.roleUpdate(param).then((response) => {
            if (response.data.status === 'Y') {
              this.$message({
                message: response.data.message,
                type: 'success'
              })
              this.$store.dispatch('initPermission')
            } else {
              this.$message({
                message: response.data.message,
                type: 'error'
              })
            }
            this.cancel()
          }).catch((error) => {
            console.log(error)
          })
        }
      })
    },
    cancel () {
      this.$router.push({path: '/roleList'})
      let tabItem = this.$store.getters.rightNav
      this.$store.dispatch('removeTab', {tabItem, fullPath: this.$route.fullPath, router: this.$router})
    },
    initSysData () {
      this.$api.systemList.systemSelect().then((response) => {
        response.data.data.map((value, i) => {
          this.optionsSys.push({label: value.name, value: value.id})
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    loop (item) {
      if (item.children.length > 0) {
        this.id.push(item.id)
        for (let i in item.children) {
          this.loop(item.children[i])
        }
      } else if (item.children.length === 0) {
        this.id.push(item.id)
      }
    }
  },
  created () {
    this.form = this.$route.params.row
    this.initTableHead()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/syssetting/roleEdit.vue